export default {
  name: "MenuButton",
  functional: true,
  props: {
    button: {
      type: Object,
      default() {
        return {};
      }
    },
    owner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h, _vm) {
    let props = _vm.props;
    return (
      <el-popover popper-class="ds-childrenbutton-popover" width="auto" trigger={props.button.trigger} class={["ds-button__more", props.owner.size]} visible-arrow={false}>
        {renderButtons(h, _vm)}
        {rendreMainButton(h, _vm)}
      </el-popover>
    );
  }
};
function renderButtons(h, _vm) {
  let props = _vm.props;
  return (
    <div class="ds-childrenbuttons-menu">
      <DsfButtonBar
        is-design={props.owner.isDesign}
        ref="buttonbarchildrenbutton"
        more-button-style={props.owner.moreButtonStyle}
        more-button-text={props.owner.moreButtonText}
        max-number={1000}
        buttons={props.button.children}
        icon-position={props.button.iconPosition}
        render-button={props.owner.renderButton}
        local={props.owner.local}
        class={{ "ds-no-padding": true }}
      ></DsfButtonBar>
    </div>
  );
}
function rendreMainButton(h, _vm) {
  let props = _vm.props;
  return (
    <DsfButton 
      slot="reference"
      key={`reference_${props.button.id}`}
      icon={props.owner.getIcon(props.button)}
      title={props.button.title}
      disabled={props.button.disabled}
      size={props.owner.size}
      type={props.button.type}
      btn-style={props.button.btnStyle}
      icon-position={props.button.iconPosition}
      style={props.button.style}
      loading={props.button.loading}
      hasChild={true}
      on-click={
        ($event)=>{
          props.owner.clickHandler(props.button, $event);
        }
      }>
      { props.button.text }
    </DsfButton>
  )
}